"use strict";
exports.__esModule = true;
var React = require("react");
var uuid_1 = require("uuid");
var GoogleMapContext_1 = require("../context/GoogleMapContext");
var operation_1 = require("../googlemap/operation");
var Portal_1 = require("./Portal");
var googleMapInfoWindow = function (props) {
    var _a = React.useContext(GoogleMapContext_1.GoogleMapContext), map = _a.map, zoom = _a.zoom, bound = _a.bound, setBound = _a.setBound;
    var _b = React.useState(null), mapObject = _b[0], setMapObject = _b[1];
    var mapObjectRef = React.useRef(null);
    var _c = React.useState(false), ready = _c[0], setReadyState = _c[1];
    var infoWindowId = React.useState(uuid_1.v4())[0];
    var createInfoWindow = function () {
        if (typeof google === 'undefined')
            return;
        var infoWindow = new google.maps.InfoWindow({
            content: "<div id=\"" + infoWindowId + "\"></div>",
            position: props.center
        });
        operation_1.mapAddObject(map, infoWindow);
        // set map object
        setMapObject(infoWindow);
        mapObjectRef.current = infoWindow;
        google.maps.event.addListener(infoWindow, 'closeclick', function () {
            setReadyState(false);
        });
        google.maps.event.addListener(infoWindow, 'domready', function () {
            infoWindow.setZIndex(props.active ? 1 : 0);
            // set map object ready
            setReadyState(true);
        });
        return infoWindow;
    };
    React.useEffect(function () {
        return function () {
            // umount mapObject using ref
            if (mapObjectRef.current)
                operation_1.mapRemoveInfowindow(mapObjectRef.current);
        };
    }, []);
    React.useEffect(function () {
        if (bound) {
            if (zoom === 1) {
                bound.extend(props.center);
                setBound(bound);
                map.fitBounds(bound);
            }
            if (zoom === -2) {
                var referenceCenter = map.getCenter();
                var markerCenter = props.center;
                var opposite = {
                    lat: referenceCenter.lat() - (markerCenter.lat - referenceCenter.lat()),
                    lng: referenceCenter.lng() - (markerCenter.lng - referenceCenter.lng())
                };
                bound.extend(props.center);
                bound.extend(opposite);
                setBound(bound);
                map.fitBounds(bound);
            }
        }
    }, [zoom]);
    var renderContent = function () {
        // render info window if no infowindow mapObject
        if (!mapObject) {
            createInfoWindow();
            return null;
        }
        // render content when mapObject is domReady
        return ready ? (React.createElement(Portal_1["default"], { window: infoWindowId },
            React.createElement("div", null, props.children))) : null;
    };
    // only render content when map existed
    return map ? renderContent() : null;
};
exports.GoogleMapInfoWindow = googleMapInfoWindow;
